import LiuCheng from './liu-cheng';


export default {
    path: 'liucheng',
    component: () => import('@layout/empty'),
    children: [
        LiuCheng,
      
    ]
}
